import { render } from "./Wizard.vue?vue&type=template&id=e0aee704&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"

import "./Wizard.vue?vue&type=style&index=0&id=e0aee704&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\_work\\21\\s\\MyMortgage_New\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0aee704"]])

export default __exports__